import React, { useState } from 'react';
import config from '../../config';
import LogoGoogle from '../../importfiles/logo-Google.png';
import './LoginFlow.css';
import AIAnimation from './AIAnimation';
import V from '../../importfiles/V.png'
import Spuntaverde from '../../importfiles/spuntaverde.png'
import AIAnimation2 from './AIAnimation2';
import AnimationSequencer from './Animationsequencer';

const LoginFlow = ({ email: initialEmail, auth, onLoginComplete, isFullAuth = false ,onSelectionChange}) => {
  // Se isFullAuth=true, parte da step 1 (email)
  // Se isFullAuth=false, parte da step 5 (onboarding)
  const [step, setStep] = useState(isFullAuth ? 1 : 5);
  const [email, setEmail] = useState(initialEmail || '');
  const [password, setPassword] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [selections, setSelections] = useState({ industry: '', job: '' });

  const firstName = email ? email.split('.')[0] : 'there';

  const handleGoogleLogin = async () => {
    try {
      if (auth && auth.signinRedirect) {
        await auth.signinRedirect({
          extraQueryParams: { identity_provider: 'Google' }
        });
      } else {
        console.error("Auth object or signinRedirect method is undefined", auth);
        alert("Configuration error: Login method not found.");
      }
    } catch (error) {
      console.error("Errore redirect Google:", error);
      alert("Errore durante il login con Google.");
    }
  };

  const handleEmailSubmit = async () => {
    if (!email) return;
    setStep(2);
  };

  const handlePasswordSubmit = async () => {
    if (!password) return;
    setLoading(true);

    try {
      // 1. Prova prima il login
      const loginRes = await fetch(`${config.apiBaseUrl}/api/auth/local`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: email, password }),
      });

      if (loginRes.ok) {
        const data = await loginRes.json();
        localStorage.setItem('token', data.data.access_token);
        if (data.data.refresh_token) localStorage.setItem('refresh_token', data.data.refresh_token);
        localStorage.setItem('username', email);
        console.log('Login riuscito');
        // Check if onboarding is already completed
        try {
          const checkRes = await fetch(`${config.apiBaseUrl}/api/onboarding/check?email=${encodeURIComponent(email)}`, {
            headers: { 'Authorization': `Bearer ${data.data.access_token}` },
          });
          if (checkRes.ok) {
            const checkData = await checkRes.json();
            if (checkData?.data?.completed) {
              if (onLoginComplete) onLoginComplete();
              return;
            }
          }
        } catch (e) {
          console.warn('Onboarding check failed, proceeding to onboarding', e);
        }
        setStep(5);
        return;
      }

      if (loginRes.status === 401) {
        // Utente non trovato: prova la registrazione
        const registerRes = await fetch(`${config.apiBaseUrl}/api/auth/register`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username: email, password, email }),
        });

        if (registerRes.status === 201 || registerRes.ok) {
          const data = await registerRes.json();
          localStorage.setItem('token', data.data.access_token);
          if (data.data.refresh_token) localStorage.setItem('refresh_token', data.data.refresh_token);
          localStorage.setItem('username', email);
          console.log('Registrazione riuscita');
          setStep(5);
          return;
        }

        if (registerRes.status === 409) {
          alert('Password errata per questo account.');
          return;
        }

        const errData = await registerRes.json().catch(() => ({}));
        alert('Errore: ' + (errData.error || 'Registrazione fallita'));
        return;
      }

      const errData = await loginRes.json().catch(() => ({}));
      alert('Errore: ' + (errData.error || 'Login fallito'));

    } catch (err) {
      console.error('Errore login/register:', err);
      alert('Errore di connessione. Riprova.');
    } finally {
      setLoading(false);
    }
  };



  const saveOnboarding = async () => {
    setLoading(true);
    const token = localStorage.getItem('token') || '';
    try {
      await fetch(`${config.apiBaseUrl}/api/onboarding/complete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(selections)
      });

      console.log(' Onboarding salvato');

      if (onLoginComplete) {
        onLoginComplete();
      }
    } catch (err) {
      console.error("Errore salvataggio:", err);
      if (onLoginComplete) {
        onLoginComplete();
      }
    }
  };

  return (
   <div className="login-flow-wrapper" 
    style={{
      ...styles.container,
      justifyContent : 'center',
      paddingLeft:'10px',
      gap: step === 1 ? '100px' : '0'
    }}>
      
     

        {/* STEP 1: Email */}
        {step === 1 && (
          <div style={styles.card1}>
          <div className="fade-in3">
            <h1 style={styles.logoTitle}>Chord  A</h1>
            <p style={styles.subtitle}>
              Smarter   quotations. <br />
              Faster results. Build to trust.
            </p>

            <button style={styles.btnSocial2} onClick={handleGoogleLogin}>
              <div style={styles.iconContainer2}>
                <img src={LogoGoogle} alt="Google" style={styles.googleIconLarge2} />
              </div>
              <span style={styles.btnSocialText}>Continue with Google</span>
            </button>

            <div className="login-divider-container">
              <div className="login-divider"></div>
              <span className="login-divider-text">Or</span>
              <div className="login-divider"></div>
            </div>
            <div className='workemail'>
            <input
              type="email"
              placeholder="Personal or work e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleEmailSubmit()}
            />
            </div>
          </div>  
          </div>
        )}

        {/* STEP 2: Password */}
        {step === 2 && (
         
          <div className="fade-in">
            <h2 style={styles.titleSmallCenter}><div style={{...styles.fontWeightBold }}>Set a password</div></h2>
          
          
           

              <div style={styles.targetInputContainer1}>
              <label style={styles.targetLabel}>New password</label>
              <input
                style={styles.targetInput}
                type="password"
                autoComplete="Test1234!"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handlePasswordSubmit()}
              />
             </div> 
            </div>
        )}

        {/* STEP 3: Check your Email (OTP) - unused with local auth */}
        {step === 3 && (
          <div style={styles.card}>
          <div className="fade-in">
            <h2 style={styles.titleSmall}>Check your e-mail to finish signing in.</h2>
            <p style={styles.subtitle}>We sent a code to <b>{email}</b></p>

            <input
              style={styles.input}
              placeholder="Verification Code"
              value={otpCode}
              onChange={(e) => setOtpCode(e.target.value)}
            />

            <button
              style={styles.btnBlack}
              disabled={loading || !otpCode}
            >
              {loading ? 'Verifying...' : 'Verify Email'}
            </button>
</div>
          </div>
        )}

        {/* STEP 4: Success Check */}
        {step === 4 && (
          <div style={styles.card}>
          <div className="fade-in" style={{ textAlign: 'center' }}>
            <div style={styles.checkCircle}><img src={Spuntaverde} alt="Check" style={styles.checkIcon} /></div>
            <h2 style={styles.titleSmall}>Check your e-mail to finish signing in.</h2>
            <p style={styles.subtitle}>We sent a code to <b>{email}</b></p>
            <button style={styles.btnBlack} onClick={() => setStep(5)}>Continue</button>
          </div>
          </div>
        )}

        {/* STEP 5: Welcome */}
        {step === 5 && (
          
          <div className="fade-in">
            <h2 style={styles.titleSmall}>
              Hi {firstName.charAt(0).toUpperCase() + firstName.slice(1)}, nice to meet you.<br />
              Before we begin, I will ask you two questions.
            </h2>
            <button style={styles.btnBeige} onClick={() => setStep(6)}>Continue</button>
          </div>
        )}

        {/* STEP 6: Industry */}
        {step === 6 && (
       
          <div className="fade-in2">
  <h3 className="question-title">What industry do you work in it?</h3>
  <h3 className="question-subtitle">You can only selected one field.</h3>
  
  <div className='contenitore'>
    {["Environmental Engineer", "Civil Engineer", "Service Manager","Account Manager","Sales","Industrial Designer"].map((item) => {
      const isActive = selections.industry === item;
      
      return (
      
        <div 
          key={item} 
          className={`profile-option-item ${isActive ? "active" : ""}`}
          onClick={() => {
            const updated = { ...selections, industry: item };
            setSelections(updated);
            onSelectionChange?.(updated);
          }}
        >
          {item}
          
          <button className="cerchietto">
            {isActive && (
              <img 
                src={V} 
                alt="Icona Attiva" 
                className='icona-spunto' 
              />
            )}
          </button>
        </div>
      );
    })}
  </div>
    <button style={styles.btnGhost} onClick={() => setStep(5)}>Back</button>
            <button
              style={styles.btnBeige2}
              disabled={!selections.industry}
              onClick={() => setStep(7)}
            >
              Continue
            </button>
          </div>
       
        )}

        {/* STEP 7: Job */}
        {step === 7 && (
          <div style={styles.card}>
          <div className="fade-in">
            <h3 style={styles.questionTitle}>
              Perfect! Now I need to know what your job is in this field.
            </h3>
           <div className='contenitore'>
  {["Environmental Engineer", "Energy", "Cosmetics", "Civil Engineer", "Industrial Designer,IOT/Sensors"].map((item) => {
    // Verifichiamo se l'item è quello selezionato nello stato
    const isActive = selections.job === item;

    return (
   
      <div 
        key={item} 
        className={`profile-option-item ${isActive ? "active" : ""}`}
        onClick={() => {
          const updated = { ...selections, job: item };
          setSelections(updated);
          onSelectionChange?.(updated); // Notifica il componente genitore
        }}
      >
        {item}
        
        <button className="cerchietto">
          {isActive && (
            <img 
              src={V} 
              alt="Icona Attiva" 
              className='icona-spunto' 
            />
          )}
        </button>
      </div>
    );
  })}
</div>
            <div style={styles.row}>
              <button style={styles.btnGhost} onClick={() => setStep(6)}>Back</button>
              <button
                style={styles.btnBeige2}
                disabled={!selections.job}
                onClick={() => setStep(8)}
              >
                Continue
              </button>
            </div>
          </div>
          </div>
        )}

        {/* STEP 8: Final */}
        {step === 8 && (
          <div style={styles.card}>
          <div className="fade-in">
            <h2 style={styles.titleSmall}>Great! Now I have everything I need, let’s get started.</h2>
            <button style={styles.btnBeige4} onClick={saveOnboarding} disabled={loading}>
              {loading ? 'Saving...' : 'Continue'}
            </button>
               <button style={styles.btnGhost} onClick={() => setStep(7)}>Back</button>
          </div>
          </div>
        )}


      {step === 1 && <AnimationSequencer />}
    </div>
  );
};

// Stili
const styles = {
  container: {
    backgroundColor: '#F8F1E7',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Inter, sans-serif'
  },
  titleSmallCenter: {
    fontSize: '1.2rem',
    color: '#333',
    fontWeight: '500',
    marginBottom: '24px',
    textAlign: 'left', // Allineato a sinistra sopra l'input
    width: '100%',
    paddingLeft: '10px'
  },
  inputLabel: {
    display: 'block',
    fontSize: '0.9rem',
    color: '#555',
    marginBottom: '8px',
    fontWeight: '500'
  },
  textAlignedCenter: {
    textAlign: 'center'
  },

  inputMinimal: {
    width: '100%',
    padding: '12px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#D9CDB7', // Input leggermente incassato
    textAlign: 'center',
    fontSize: '1rem',
    outline: 'none',
    color: '#333'
  },
  card: {
    backgroundColor: '#EFE6D5',
    border: '2px solid #C17F52',
    borderRadius: '20px',
    padding: '30px 40px',
    width: '509px',
    textAlign: 'center',
    boxShadow: '5px 5px 0px 0px #ADA9A3',
    height: 'fit-content'
  },
    card1: {
    backgroundColor: '#EFE6D5',
    border: '2px solid #C17F52',
    borderRadius: '20px',
    padding: '30px 40px',
    width: '300px',
    textAlign: 'center',
    boxShadow: '5px 5px 0px 0px #ADA9A3',
    height: '400px'
  },
  logoTitle: {
    fontSize: '3.5rem',
    fontWeight: '300',
    color: '#333',
    marginBottom: '8px'
  },
  targetLabel: {
    fontFamily: '"Inter", sans-serif',
    fontSize: '1.2rem',
    color: '#4A4238',
    fontWeight: '500'
  },

  // L'input vero e proprio che sembra "incassato"
  targetInput: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#D9CDB7', // Colore beige scuro
    border: '1px solid #C4B599',
    borderRadius: '12px',
    textAlign: 'center',
    fontSize: '1rem',
    color: '#6B5E5E',
    outline: 'none',
    // Questo toglie l'effetto azzurro/bianco del browser
    WebkitAppearance: 'none',
    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)' // Ombra interna per profondità
  },
  targetInputContainer1: {
    backgroundColor: '#F1E6D2', // Sfondo panna interno
    border: '2px solid #C17F52', // Bordo marrone spesso visibile in foto
    borderRadius: '20px',
    padding: '25px 40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)', // Leggera ombra esterna
    width: '100%',
    maxWidth: '350px',
    margin: '0 auto'
  },
   targetInputContainer: {
    backgroundColor: '#F1E6D2', // Sfondo panna interno
   
    borderRadius: '20px',
    padding: '25px 40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)', // Leggera ombra esterna
    width: '100%',
    maxWidth: '350px',
    margin: '0 auto'
  },
  subtitle: {
    fontSize: '1rem',
    color: '#6B5E5E',
    marginBottom: '32px',
    lineHeight: '1.4'
  },
  title: {
    fontSize: '1.8rem',
    color: '#333',
    marginBottom: '24px',
    fontWeight: '400'
  },
  inputWrapper: {
    backgroundColor: '#E5D9C3', // Sfondo leggermente più scuro per l'area input
    padding: '20px',
    borderRadius: '16px',
    textAlign: 'center'
  },
  titleSmall: {
    fontSize: '1.4rem',
    color: '#333',
    marginBottom: '16px',
    fontWeight: '400',
    lineHeight: '1.3'
  },
  questionTitle: {
    fontSize: '1.2rem',
    marginBottom: '8px',
    fontWeight: '500'
  },
  input: { 
    width: '90%', 
    padding: '16px', 
    borderRadius: '50px', 
    border: '1px solid #D1C4AC', 
    backgroundColor: 'transparent', 
    marginBottom: '20px', 
    textAlign: 'center', 
    fontSize: '1rem' 
  },
  btnBlack: {
    width: '100%',
    padding: '16px',
    borderRadius: '50px',
    border: 'none',
    backgroundColor: '#333',
    color: 'white',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: '500',
    marginBottom: '12px'
  },
  btnBeige: {
    padding: '12px 32px',
    borderRadius: '50px',
    border: '1px solid #C4B599',
    backgroundColor: '#E8DCC4',
    cursor: 'pointer',
    fontSize: '1rem',
  }, 
  btnBeige2: {
    padding: '12px 12px',
    borderRadius: '50px',
    border: '1px solid #C4B599',
    backgroundColor: '#E8DCC4',
    cursor: 'pointer',
    fontSize: '1rem',
    marginTop:'10px'
  },
  btnBeige3: {
    padding: '12px 2px',
    borderRadius: '50px',
    border: '1px solid #C4B599',
    backgroundColor: '#E8DCC4',
    cursor: 'pointer',
    fontSize: '1rem',
    marginTop:'10px'
  },
  btnBeige4: {
    padding: '12px 12px',
    borderRadius: '50px',
    border: '1px solid #C4B599',
    backgroundColor: '#E8DCC4',
    cursor: 'pointer',
    fontSize: '1rem',
    margin:'12px'
    
  },
  btnBeige5: {
    padding: '12px 2px',
    borderRadius: '50px',
    border: '1px solid #C4B599',
    backgroundColor: '#E8DCC4',
    cursor: 'pointer',
    fontSize: '1rem',
    margin:'12px'
    
  },
  btnSocial: {
    width: '100%',
    padding: '12px',
    borderRadius: '50px',
    border: '1px solid #D1C4AC',
    backgroundColor: '#E8DCC4',
    marginBottom: '12px',
    cursor: 'pointer',
    fontSize: '0.95rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  btnSocial2: {
    width: '100%',
    padding: '12px',
    borderRadius: '50px',
    border: '1px solid #D1C4AC',
    backgroundColor: '#E8DCC4',
    marginBottom: '12px',
    cursor: 'pointer',
    fontSize: '0.95rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  iconContainer2: {
    // Crea il cerchio bianco dietro l'icona se vuoi l'effetto "staccato"
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    
  },

  googleIconLarge2: {
    width: '35px', 
    height: '25px'
  },

  btnSocialText2: {
    fontSize: '1rem',
    fontWeight: '500',
    color: '#333',
    flexGrow: 1, // Spinge il testo verso il centro
    textAlign: 'center',
    marginRight: '40px' // Bilancia l'icona a sinistra per centrare il testo
  },
  btnGhost: {
    background: 'none',
    border: 'none',
    color: '#BC8F6F',
    cursor: 'pointer',
    fontSize: '1rem',
    marginTop: '12px'
  },
  optionBtn: {
    width: '100%',
    padding: '14px 20px',
    margin: '6px 0',
    borderRadius: '16px',
    border: '1px solid #C4B599',
    backgroundColor: '#E8DCC4',
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
    fontSize: '1rem'
  },
  linkText: {
    marginTop: '16px',
    color: '#BC8F6F',
    cursor: 'pointer',
    fontSize: '0.9rem'
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    marginTop: '24px'
  },
  checkCircle: {
    width: '60px',
    height: '60px',
    backgroundColor: '#FFFFFF',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto 20px',
    color: '#D1C4AC',
    fontSize: '2rem'
  },
  fontWeightBold: {
    fontWeight: 'bold'
  },
  optionsContainer: {
    backgroundColor: '#EFE6D5',
    padding: '12px',
    borderRadius: '20px',
    border: '1px solid #D9CDB7',
    marginBottom: '20px'
  },
  passwordHint: {
    fontSize: '0.85rem',
    color: '#888',
    marginTop: '-10px',
    marginBottom: '20px'
  }
};

export default LoginFlow;